module.exports = __webpack_public_path__ + "static/media/25.9debc031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/25.jpg
// module id = 484
// module chunks = 0